//#Global Imports
import React from "react";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
//#end Global Imports

//#Local Imports
import Modal from "../../../components/ui/Modal";
import Typograpy from "../../../components/ui/Typography";
import Button from "../../../components/ui/Button";
import Checkbox from "../../../components/ui/Checkbox";
import { KYCCompleted, KYCVerification } from "../../../assets/Icons";
import IUserDocuments from "../userDocuments";
import { Mixpanel } from "../../../constants/mixpanel";
//#end Local Imports

const KycVerifiedAndIsAgreeModal: React.FC<IUserDocuments.IKycAVerifiedndIsAgreeModalProps> = ({
  isModalOpen,
  setIsModalOpen,
  setIsAgree,
  isAgree,
  kycVerificationAgreementNote,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      modalClass="!pt-6 md:pr-11 !rounded md:!w-auto md:overflow-hidden overflow-y-scroll max-h-[80%]"
      visible={isModalOpen === "1" || isModalOpen === "KYCVerified"}
      closeHandler={() => {
        setIsModalOpen("");
        isModalOpen === "1" && navigate("/remitter");
      }}
    >
      <div
        className={clsx(
          isModalOpen === "1" ? "mt-10" : "mt-0",
          "pb-5 md:pl-[30px] md:pr-[18px] flex item-start justify-between",
        )}
      >
        <div
          className={clsx(
            isModalOpen === "1" ? "items-center" : "items-center md:items-start",
            "flex flex-col md:mr-12",
          )}
        >
          <div className="md:pb-[37px] pb-12">
            {isModalOpen === "1" && (
              <Typograpy
                tagType="div"
                text="Welcome to HOP"
                className="mb-4 text-xl font-semibold text-black font-lato md:hidden"
              />
            )}
            <Typograpy
              tagType="div"
              text={isModalOpen === "1" ? "Welcome to" : "Hi! User"}
              className={clsx(
                isModalOpen === "1" ? "hidden md:flex" : "flex",
                "text-black font-semibold text-[28px] font-lato",
              )}
            />
            <Typograpy
              tagType="div"
              text={isModalOpen === "1" ? "moneyHOP" : "“Your one time KYC is completed”"}
              className={clsx(
                isModalOpen === "1" ? "hidden md:flex" : "flex",
                "text-black font-semibold text-[38px] font-lato",
              )}
            />
            {isModalOpen === "1" && (
              <Typograpy
                tagType="div"
                text="We will be verifying your documents for KYC to provide you the seamless experience."
                className="text-base font-normal text-black md:text-lg font-lato"
              />
            )}
          </div>
          <div className="md:hidden mb-[61px]">
            {isModalOpen === "1" ? (
              <KYCVerification width="293px" />
            ) : (
              <KYCCompleted width="293px" />
            )}
          </div>
          {isModalOpen !== "1" && (
            <div className="pb-12 text-base font-normal text-grey-1400 md:text-xl font-lato">
              You can upload some more documents to make your journey more seamless,
              <span className="cursor-pointer text-primary">try now</span>
            </div>
          )}
          {isModalOpen === "1" && (
            <div className="mb-16">
              <Checkbox
                label={kycVerificationAgreementNote}
                value="true"
                name="conditionalNote"
                labelClassName="w-full ml-[26px] cursor-pointer"
                handleChange={(e) => {
                  setIsAgree(e.target.checked);
                }}
              />
            </div>
          )}
          <Button
            bgColor={
              isModalOpen === "1"
                ? isAgree
                  ? "bg-primary-1200"
                  : "bg-grey-150"
                : "bg-secondary-600"
            }
            fontStyle={{
              fontFamily: "",
              fontSize: "text-lg",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            borderStyle={{
              borderWidth: "border-none",
              borderRadius: "rounded",
            }}
            disabled={isModalOpen === "1" && !isAgree}
            className={clsx(
              isModalOpen === "1"
                ? "py-[14px] px-[120px] kyc-confirm-btn"
                : "py-[11px] justify-start w-full md:w-1/2",
            )}
            onClickHandler={() => {
              isModalOpen === "1" ? setIsModalOpen("2") : navigate("/user-details");
              Mixpanel.track("Proceed button_KYC complete ");
            }}
          >
            {isModalOpen === "1" ? "Confirm" : "Proceed"}
          </Button>
        </div>
        <div className="hidden md:flex">
          {isModalOpen === "1" ? <KYCVerification /> : <KYCCompleted />}
        </div>
      </div>
    </Modal>
  );
};

export default KycVerifiedAndIsAgreeModal;
